import { render } from "./Glosario.vue?vue&type=template&id=5e90a54b&scoped=true"
import script from "./Glosario.vue?vue&type=script&lang=js"
export * from "./Glosario.vue?vue&type=script&lang=js"

import "./Glosario.vue?vue&type=style&index=0&id=5e90a54b&lang=scss&scoped=true"

import exportComponent from "/opt/web_acelerometrica_publica/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e90a54b"]])

export default __exports__